export default {
    history: {
        title: "Historia",
        customerHistory: "Historial del cliente",
        globalHistory: "Historia global",
        type: "Escribe",
        id: "ID de tipo de historial",
        action: "Acción",
        status: "Estado",
        statusReason: "Motivo del estado",
        description: "Descripción",
        modBy: "Modificado por",
        started: "Comenzó en",
        ended: "Terminó el",
        duration: "Duración",
        details: "Detalles de la historia",
        general: "General",
        presets: {
            jobHistory: "NCS: Historial de Trabajo",
            radioCommandHistory: "NCS: Historial de Comandos de Radios",
            towerCommandHistory: "NCS: Historial de Comandos de la Estación Base"
        },        
        actions: {
            COMMAND: "Dominio",
            CREATE: "Crear",
            DELETE: "Borrar",
            TUNING: "Afinación",
            UPDATE: "Actualizar"
        },
        statuses: {
            COMPLETED: "Terminada",
            IN_PROGRESS: "En progreso",
            CANCELLED: "Cancelada",
            FAILED: "Fallida"
        },
        types: {
            SET: "Establecer",
            TOWER: "Estación base",
            RADIO: "Radio",
            ALARM_RULE: "Regla de alarma",
            ALARM_SUPPRESSION: "Supresión de alarma",
            JOB: "Trabajo",
            RADIO_RULE: "Regla de radio",
            NETWORK_PLAN: "Plan de red",
            TUNING: "Afinación",
            CUSTOMER: "Cliente",
            CHANNEL_CONFIG: "Configuración de canal",
            CSV_IMPORT: "Importación CSV",
            TOWER_SOFTWARE: "Software de torre",
            RNI: "RNI"
        },
        sets: {
            idList: "Lista de identificaciones",
            idAddList: "ID para agregar",
            idRemoveList: "ID para eliminar",
            name: "Nombre",
            filterList: "Lista de filtros",
        },
        tuning: {
            tuningChanges: "Cambios de afinación",
            channelBalanceChanges: "Cambios en el equilibrio del canal",
            otherInfo: "Otra información"
        },
        job: {
            config: "Configuración de Trabajo",
            errors: "Errores de Trabajo",
            metrics: "Métricas de trabajo",
            channelBal: "Equilibrio de Canal",
            nco: "NCO",
            buddy: "Compañero",
            buddyDistribution: "Distribución de Compañeros",
            rapidTune: "Sintonización rápida",
            eca: "ECA",
            prePostProcessing: "Procesamiento Pre/Post"
        },
        radioRule: {
            diff: "Diferencias",
            update: "Campos actualizados",
            created: "Creado"
        },
        channelConfig: {
            deleted: "Eliminado"
        }
    },
    chd: {
        attemptDNA: "La información del intento no se aplica",
        attempts: "Intentos",
        changes: "Cambios",
        lastAttemptDate: "Intento más reciente",
        nextAttemptDate: "Próximo intento",
        messages: "Mensajes",
        noMessages: "No hay mensajes para este evento de historial",
        commandHistory: "Historial de comandos",
        commandEventId: "ID de evento de comando",
    },
}
